/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Liability_S61_Item_3Inputs */

const es_tyc_liability_s61_item_3 = /** @type {(inputs: Tyc_Liability_S61_Item_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interrupciones del servicio causadas por fallos en Fuentes Conectadas fuera del control razonable de Nexata.`)
};

const en_tyc_liability_s61_item_3 = /** @type {(inputs: Tyc_Liability_S61_Item_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Service interruptions caused by failures in Connected Sources beyond Nexatas reasonable control.`)
};

/**
* | output |
* | --- |
* | "Service interruptions caused by failures in Connected Sources beyond Nexatas reasonable control." |
*
* @param {Tyc_Liability_S61_Item_3Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_liability_s61_item_3 = /** @type {((inputs?: Tyc_Liability_S61_Item_3Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Liability_S61_Item_3Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_liability_s61_item_3(inputs)
	return en_tyc_liability_s61_item_3(inputs)
});
export { tyc_liability_s61_item_3 as "tyc.liability.s61_item_3" }